export enum ContactType {
  Business = 'BUSINESS',
  Owner = 'OWNER',
  Personal = 'PERSONAL',
  ManageDisputes = 'DISPUTE_HANDLING',
}
